import { createModal } from "Components/Modal/helpers/createModal";
import { TUTORIAL_TYPE_RECORD } from "../consts/TUTORIAL_TYPE_RECORD";
import { TutorialType } from "../types/TutorialType";

export const useTutorialModal = createModal<TutorialType>({
	beforeClose: () => {
		const type = useTutorialModal.getState().item;

		if (!type) return;

		const key = TUTORIAL_TYPE_RECORD[type].localStorageKey;

		window.localStorage.setItem(key, "true");
	},

	isOpenable: (item) => {
		if (!item) return true;
		const isTutorialCompleted =
			window.localStorage.getItem(
				TUTORIAL_TYPE_RECORD[item].localStorageKey
			) === "true";
		if (!isTutorialCompleted) return true;

		return false;
	},
});
